/**
 * D69: a table never scrolls inside the page. The DSM DataTable's `height` is
 * a maximum (its viewport is the smaller of `height` and its rows): this value
 * lets every row show, the page scrolls as one. A list that can grow long is
 * paginated instead.
 */
export const FULL_HEIGHT = 1_000_000;
